import { ProteinViewer } from "@/components/protein-viewer"
import { GiMolecule } from "react-icons/gi"

const PROTEIN_EXTENSIONS = ['pdb', 'pdbqt', 'cif', 'mmcif', 'mol2', 'sdf']

/** @param {string} url */
export function isProteinFile(url) {
  if (!url) return false
  const ext = url.split('.').pop()?.split('?')[0]?.toLowerCase()
  return PROTEIN_EXTENSIONS.includes(ext)
}

/** @param {string} url */
function formatFilename(url) {
  let filename;
  try {
    filename = new URL(url).pathname.split('/').pop() || url;
  } catch {
    filename = url.split('/').pop()?.split('?')[0] || url;
  }
  return filename.replace(/_/g, ' ');
}

/**
 * @param {{
 *   files: Array<{ url: string, type: string }>,
 *   defaultFile: { url: string, type: string },
 * }} props
 */
function ChatBubbleProteinFileCard({ files, defaultFile }) {
  const allProteinUrls = files.filter(f => isProteinFile(f.url)).map(f => f.url)
  const filename = formatFilename(defaultFile.url)

  return (
    <ProteinViewer fileUrls={allProteinUrls} defaultFileUrl={defaultFile.url}>
      <ProteinViewer.Trigger asChild>
        <button
          className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 mb-3 w-full text-left"
          title="View 3D structure"
        >
          <div className="flex items-center justify-center w-10 h-10 rounded-md bg-purple-500/10 text-purple-400 flex-shrink-0">
            <GiMolecule className="w-5 h-5" />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground truncate">{filename}</p>
            <p className="text-xs text-muted-foreground mt-0.5 capitalize">{defaultFile.type.replace('_', ' ')}</p>
          </div>

          <span className="sr-only">View 3D structure</span>
        </button>
      </ProteinViewer.Trigger>
    </ProteinViewer>
  )
}

export default ChatBubbleProteinFileCard
